<template>
  <page>
    <span slot="page-title">Email Verified</span>
    <p>Thanks for verifying your email address.</p>
    <p>You will be redirected to the home page in {{ seconds }} seconds.  <a href="/" @click="goHome($event)">Click here</a> to go there now.</p>
  </page>
</template>

<script>
import { Page } from '@/components'

const name = 'email_verified'

const methods = {
  goHome ($event) {
    if ($event) {
      $event.preventDefault()
    }
    this.$router.replace({ name: 'home' })
  }
}

const components = {
  Page
}

export default {
  name,
  methods,
  components,
  metaInfo: {
    title: 'Email Verified'
  },
  data () {
    return {
      seconds: 4
    }
  },
  mounted () {
    let interval = setInterval(() => {
      clearInterval(interval)
      interval = setInterval(() => {
        this.seconds -= 1
        if (this.seconds === 0) {
          this.goHome()
          clearInterval(interval)
        }
      }, 1000)
    }, 200)
  }
}
</script>
